// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__15zG6","info":"Note_info__1m-g-","note":"Note_note__iw7oA","actions":"Note_actions__2RNs8"};